import React from 'react'

import { sharedData } from '../../../models/shared_data'
import { CurFormatComponent } from '../../shared/cur_format/cur_format.component'

export class OrderBonusApply extends React.Component {

  constructor(props) {
    super(props)

    this.useBonuses = this.useBonuses.bind(this)
    this.clearBonuses = this.clearBonuses.bind(this)
  }

  bonusNotAvailable() {
    return !sharedData.data.client || !sharedData.data.site_params.is_bonus_avaliable
  }

  haveNoBonuses() {
    return sharedData.data.client.bonuses <= 0
  }

  // Сервер сам решает, сколько можно списать (в режиме «только 100% заказа»
  // при нехватке бонусов он вернёт 0) — тогда предлагать списание нельзя.
  nothingToSpend() {
    return (this.props.order.maximum_bonus_spend || 0) <= 0
  }

  // Режим «списание только на 100% заказа»: молча прятать блок нельзя —
  // у клиента есть бонусы, и он должен понимать, почему их не предлагают.
  fullOrderOnly() {
    return !!this.props.order.bonus_spend_full_order_only
  }

  missingSum() {
    const o = this.props.order
    return Math.max((o.sum || 0) - (sharedData.data.client.bonuses || 0), 0)
  }

  useBonuses(e) {
    e.preventDefault()
    const o = this.props.order
    this.props.changeBonus(o.maximum_bonus_spend)
  }

  clearBonuses(e) {
    e.preventDefault()
    this.props.changeBonus(0)
  }


  render() {
    const o = this.props.order
    if(this.bonusNotAvailable() || this.haveNoBonuses())
      return null
    if(o.bonus_sum <= 0 && this.nothingToSpend()) {
      if(!this.fullOrderOnly())
        return null
      return (
        <div className="bonus-apply">
          <span>Бонусами можно оплатить только весь заказ целиком, не хватает
          &nbsp;
          <CurFormatComponent price={ this.missingSum() } /></span>
        </div>
      )
    }
    return (
      <div className="bonus-apply">
        {o.bonus_sum == 0 &&
          <a href='' className="btn btn--blue" onClick={this.useBonuses}>
          Использовать бонусы
          &nbsp;
          <CurFormatComponent price={ o.maximum_bonus_spend }/>
          </a>
        }
        {o.bonus_sum > 0 &&
          <div>
            <span>Использовано
            &nbsp;
            <CurFormatComponent price={o.bonus_sum} />
            &nbsp;
            бонусов &nbsp;</span>
            <a href='' onClick={this.clearBonuses}>Отменить</a>
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/cart/make_order/order_bonus_apply.component.jsx